'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactSwipeable = require('react-swipeable');

var _reactSwipeable2 = _interopRequireDefault(_reactSwipeable);

var _redux = require('redux');

var _reactRedux = require('react-redux');

var _info = require('redux/modules/info');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
  SidePanel: {
    displayName: 'SidePanel'
  }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
  filename: '/home/Devel/web/productionRc/Agama2016/src/components/SidePanel/SidePanel.js',
  components: _components,
  locals: [],
  imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
  return function (Component) {
    return _reactTransformCatchErrors2(Component, id);
  };
}

var SidePanel = _wrapComponent('SidePanel')((_dec = (0, _reactRedux.connect)(function (state) {
  return { info: state.info.data };
}, // info nese informace o panelech (zatim spatne pojmenovane)
function (dispatch) {
  return (0, _redux.bindActionCreators)({ upload: _info.upload, load: _info.load, setUiProps: _info.setUiProps, panelVisibleToSide: _info.panelVisibleToSide }, dispatch);
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(SidePanel, _Component);

  function SidePanel() {
    (0, _classCallCheck3.default)(this, SidePanel);
    return (0, _possibleConstructorReturn3.default)(this, (SidePanel.__proto__ || (0, _getPrototypeOf2.default)(SidePanel)).apply(this, arguments));
  }

  (0, _createClass3.default)(SidePanel, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          info = _props.info,
          setUiProps = _props.setUiProps,
          panelVisibleToSide = _props.panelVisibleToSide,
          name = _props.name,
          onePanel = _props.onePanel; // eslint-disable-line no-shadow

      var type = this.props.childPanelName ? 'top-menu' : 'deeper-menu';
      var childPanelName = this.props.childPanelName ? this.props.childPanelName : null;
      var parentPanelName = this.props.parentPanelName ? this.props.parentPanelName : null;
      var styles = require('./SidePanel.scss');
      var nowState = info.ui[name + 'Display'];
      var nowStateArray = nowState.split(' ');
      var mySide = nowStateArray[1];
      var zType = info.ui[name + 'Z'];
      // funkce pro uplne schování všeho do strany
      var panelVisibleToSideF = function panelVisibleToSideF() {
        return panelVisibleToSide({ name: parentPanelName || name, childPanelName: childPanelName || name, mySide: mySide });
      };
      var style = {
        color: 'black'
      };
      // const setUiProps2 = (obj) =>{
      //   setUiProps(obj);
      // };
      var neg = function neg(side) {
        return side === 'left' ? 'right' : 'left';
      };

      var getClassNames = function getClassNames() {
        return nowStateArray.map(function (part) {
          return styles[part];
        }).join(' ') + ' ' + styles[type] + ' ' + styles[zType] + (onePanel ? ' ' + styles.onePanel : '');
      };

      var iconToSide = function iconToSide(side) {
        var result = void 0;
        if (side === 'left') {
          result = _react3.default.createElement('span', { className: 'glyphicon glyphicon-menu-left', 'aria-hidden': 'true' });
        } else {
          result = _react3.default.createElement('span', { className: 'glyphicon glyphicon-menu-right', 'aria-hidden': 'true' });
        }
        return result;
      };

      var startSwiping = function startSwiping() {
        setUiProps({
          name: 'swiping',
          value: true
        });
      };
      var stopSwiping = function stopSwiping() {
        setUiProps({
          name: 'swiping',
          value: false
        });
      };

      var getSwipeFunction = function getSwipeFunction(direction) {
        var oneCase = nowState + ' to ' + direction;

        var saveLastVisibleState = function saveLastVisibleState() {
          // console.log('ukladam stav: ' + info.ui[(parentPanelName || name) + 'Z'] + ',' + info.ui[(childPanelName || name) + 'Z']);
          var value = [info.ui[(parentPanelName || name) + 'Z'], info.ui[(childPanelName || name) + 'Z']];
          setUiProps({
            name: (parentPanelName || name) + 'LastStateBeforeHiddenTo' + direction,
            value: value
          });
          return value;
        };

        var visibleToSide = function visibleToSide() {
          if (parentPanelName) {
            setUiProps({
              name: parentPanelName + 'Z',
              value: 'sub'
            });
            setUiProps({
              name: name + 'Z',
              value: 'top'
            });
            setUiProps({
              name: name + 'Display',
              value: 'semiPushed ' + mySide
            });
          } else {
            panelVisibleToSideF();
          }
        };
        var semiPushedToCenter = function semiPushedToCenter() {
          setUiProps({
            name: name + 'Display',
            value: 'visible ' + mySide
          });
          setUiProps({
            name: name + 'Z',
            value: 'top'
          });
          if (parentPanelName) {
            setUiProps({
              name: parentPanelName + 'Z',
              value: 'top'
            });
          }
        };
        var semiPushedToSide = function semiPushedToSide() {
          // nove
          saveLastVisibleState();
          setUiProps({
            name: parentPanelName + 'Display',
            value: 'pushed ' + mySide
          });
          setUiProps({
            name: name + 'Display',
            value: 'pushed ' + mySide
          });
        };
        var pushedToCenter = function pushedToCenter() {
          var lastStateBeforeHidden = info.ui[(parentPanelName || name) + 'LastStateBeforeHiddenTo' + neg(direction)];
          var visible = lastStateBeforeHidden[0] === 'top';
          var childVisible = lastStateBeforeHidden[1] === 'top';
          var bothWereVisible = visible && childVisible;
          setUiProps({
            name: (parentPanelName || name) + 'Display',
            value: 'visible ' + mySide
          });
          setUiProps({
            name: (parentPanelName || name) + 'Z',
            value: lastStateBeforeHidden[0]
          });
          setUiProps({
            name: (childPanelName || name) + 'Display',
            value: (!bothWereVisible ? 'semiPushed ' : 'visible ') + mySide
          });
          setUiProps({
            name: (childPanelName || name) + 'Z',
            value: lastStateBeforeHidden[1]
          });
        };

        return function (event) {
          var isClick = event == null || event.type === 'click'; // eslint-disable-line 
          if (!isClick) {
            // e je null, pokud je funkce getSwipeFunction volána explicitne (z metody onClickPanel)
            event.preventDefault();
            event.stopPropagation();
          }
          if (info.ui.swiping) return;
          // console.log(oneCase);
          if (oneCase === 'visible left to left') {
            if (!isClick) startSwiping();
            visibleToSide();
          }
          if (oneCase === 'visible right to right') {
            if (!isClick) startSwiping();
            visibleToSide();
          }

          if (oneCase === 'semiPushed left to right') {
            if (!isClick) startSwiping();
            semiPushedToCenter('left');
          }
          if (oneCase === 'semiPushed left to left') {
            if (!isClick) startSwiping();
            semiPushedToSide();
          }
          if (oneCase === 'semiPushed right to right') {
            if (!isClick) startSwiping();
            semiPushedToSide();
          }
          if (oneCase === 'semiPushed right to left') {
            if (!isClick) startSwiping();
            semiPushedToCenter('right');
          }

          if (oneCase === 'pushed left to right') {
            if (!isClick) startSwiping();
            pushedToCenter('left');
          }
          if (oneCase === 'pushed right to left') {
            if (!isClick) startSwiping();
            pushedToCenter('right');
          }
        };
      }; // end of  getSwipeFunction

      var checkWheatherAlreadyClickedButton = function checkWheatherAlreadyClickedButton(paramaTarget) {
        var body = document.body;
        var target = paramaTarget;
        while (target !== body) {
          if (target.tagName === 'A' || target.tagName === 'BUTTON') return true;
          target = target.parentElement;
        }
        return false;
        // if (target.classList.contains('likeButton')) return;
      };

      var onClickPanel = function onClickPanel(event) {
        // pokud už šlo z kliku na tlačítko
        if (checkWheatherAlreadyClickedButton(event.target)) return;
        var anotherName = _this2.props.childPanelName ? _this2.props.childPanelName : _this2.props.parentPanelName;
        if (nowStateArray[0] === 'pushed') {
          getSwipeFunction(neg(nowStateArray[1]))(null, null);
          return;
        }

        if (zType === 'sub') {
          if (anotherName) {
            setUiProps({
              name: anotherName + 'Z',
              value: 'sub'
            });
            setUiProps({
              name: name + 'Z',
              value: 'top'
            });
          }
        }
      };

      var onBtnClick = function onBtnClick(event) {
        event.preventDefault();
        event.stopPropagation();
        var ff = getSwipeFunction(nowStateArray[1]);
        ff();
      };
      var onBtnClickNeg = function onBtnClickNeg(event) {
        event.preventDefault();
        event.stopPropagation();
        var ff = getSwipeFunction(neg(nowStateArray[1]));
        ff();
      };

      var button1 = '';
      if (nowStateArray[0] === 'visible') {
        button1 = _react3.default.createElement(
          'button',
          { type: 'button', className: 'btn btn-default', onClick: onBtnClick },
          iconToSide(nowStateArray[1])
        );
      }
      if (nowStateArray[0] === 'semiPushed') {
        button1 = _react3.default.createElement(
          'button',
          { type: 'button', className: 'btn btn-default', onClick: onBtnClickNeg },
          iconToSide(neg(nowStateArray[1]))
        );
      }
      if (nowStateArray[0] === 'pushed') {
        button1 = _react3.default.createElement(
          'button',
          { type: 'button', className: 'btn btn-default', onClick: onBtnClickNeg },
          iconToSide(neg(nowStateArray[1]))
        );
      }

      return _react3.default.createElement(
        _reactSwipeable2.default,
        { onSwipingLeft: getSwipeFunction('left'), onSwipingRight: getSwipeFunction('right'), onSwiped: stopSwiping },
        _react3.default.createElement(
          'nav',
          { itemprop: 'additionalType', itemScope: true, itemType: 'http://schema.org/SiteNavigationElement', className: styles.agSidePanel + ' noPrint', onClick: onClickPanel },
          _react3.default.createElement(
            'div',
            { className: getClassNames(), style: style },
            _react3.default.createElement(
              'div',
              { className: styles.visiblePanelPart },
              _react3.default.createElement(
                'div',
                { className: styles.agPanelIcons + ' btn-group-xs', role: 'group' },
                button1
              ),
              _react3.default.createElement(
                'div',
                { className: styles.agPanelBody },
                this.props.children
              )
            )
          )
        )
      );
    }
  }]);
  return SidePanel;
}(_react2.Component), _class2.propTypes = {
  info: _react2.PropTypes.object,
  load: _react2.PropTypes.func.isRequired,
  upload: _react2.PropTypes.func.isRequired,
  setUiProps: _react2.PropTypes.func.isRequired,
  panelVisibleToSide: _react2.PropTypes.func.isRequired,
  name: _react2.PropTypes.string.isRequired,
  childPanelName: _react2.PropTypes.string,
  parentPanelName: _react2.PropTypes.string,
  /* children: React.PropTypes.element.isRequired, */
  children: _react3.default.PropTypes.oneOfType([_react3.default.PropTypes.arrayOf(_react3.default.PropTypes.node), _react3.default.PropTypes.node]),
  onePanel: _react2.PropTypes.bool
}, _class2.defaultProps = {
  children: []
}, _temp)) || _class));

exports.default = SidePanel;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SidePanel/SidePanel.js
// module id = 1191
// module chunks = 0